import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  setSelectedMenu,
  getAvailableAgentList,
} from "../../Redux/Actions/actions";
import { BaseUrl, BaseUrlReports } from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Spinner } from "react-bootstrap";
import { TiWarningOutline } from "react-icons/ti";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FilterListIcon from "@mui/icons-material/FilterList";
import FileSaver from "file-saver";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";

import {
  Button,
  Stack,
  Pagination,
  Typography,
  Box,
  Drawer,
  ButtonGroup,
} from "@mui/material";
import { Hourglass } from "react-loader-spinner";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";
import moment from "moment";

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

const AgentStatisticsReport = (props) => {
  const selectAgentRef = useRef(null);
  const today = new Date();
  const todayDate = today.toISOString().split("T")[0];
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();

  const [fromYear, setFromYear] = useState("");
  const animatedComponents = makeAnimated();
  const [apiCallsMade, setApiCallsMade] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [agentspinner, setagentspinner] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [agentlogindatalist, setAgentLoginDataList] = useState([]);
  const [selectedagent, setSelectedagent] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [fromdate, setFromdate] = useState(todayDate);
  const [todate, setTodate] = useState(todayDate);
  const [fromDateError, setFromDateError] = useState("");
  const [toDateError, setToDateError] = useState("");
  const [yearError, setYearError] = useState("");
  const [monthError, setMonthError] = useState("");

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
    setMonthError("");
  };

  //   const handleYearChange = (e) => {
  //     const selectedOption = e.target.value;
  //     setFromYear(selectedOption);
  //     setYearError("");

  //     // Always set todate to today
  //     setTodate(todayDate);

  //     let fromDate = todayDate; // Default to today

  //     switch(selectedOption) {
  //       case "Today":
  //         fromDate = todayDate;
  //         break;
  //       case "ThisWeek":
  //         // Get start of current week (Sunday)
  //         const sunday = new Date(today);
  //         sunday.setDate(today.getDate() - today.getDay());
  //         fromDate = sunday.toISOString().split('T')[0];
  //         break;
  //       case "LastWeek":
  //         // Get start of previous week (Sunday of last week)
  //         const lastSunday = new Date(today);
  //         lastSunday.setDate(today.getDate() - today.getDay() - 7);
  //         fromDate = lastSunday.toISOString().split('T')[0];
  //         break;
  //       case "ThisMonth":
  //         // Get first day of current month
  //         const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  //         fromDate = firstDay.toISOString().split('T')[0];
  //         break;
  //       case "LastMonth":
  //         // Get first day of previous month
  //         const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  //         fromDate = firstDayLastMonth.toISOString().split('T')[0];
  //         break;
  //       case "Custome":
  //         // Don't set fromdate - let user choose
  //         return;
  //       default:
  //         fromDate = todayDate;
  //     }

  //     setFromdate(fromDate);
  //   };

  const handleYearChange = (e) => {
    const selectedOption = e.target.value;
    setFromYear(selectedOption);
    setYearError("");

    // Always set todate to today
    setTodate(todayDate);

    let fromDate = todayDate; // Default to today

    switch (selectedOption) {
      case "Today":
        fromDate = todayDate;
        break;

      case "ThisWeek":
        const sunday = new Date(today);
        sunday.setDate(today.getDate() - today.getDay());
        fromDate = sunday.toISOString().split("T")[0];
        break;

      case "LastWeek":
        const lastSunday = new Date(today);
        lastSunday.setDate(today.getDate() - today.getDay() - 7);
        fromDate = lastSunday.toISOString().split("T")[0];
        break;

      case "ThisMonth":
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        fromDate = firstDay.toISOString().split("T")[0];
        break;

      case "LastMonth":
        const firstDayLastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        fromDate = firstDayLastMonth.toISOString().split("T")[0];
        break;

      case "Custome":
        // Show today by default, but user can modify it later
        setFromdate(todayDate);
        setTodate(todayDate);
        return;

      default:
        fromDate = todayDate;
    }

    setFromdate(fromDate);
  };

  const handelShowFilter = () => {
    setShowFilter(true);
  };

  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  const optionsAgent = props.DropDownAgentList.map((agent) => ({
    value: agent.id,
    label: agent.username,
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  useEffect(() => {
    if (!apiCallsMade) {
      props.getAvailableAgentList();
      setApiCallsMade(true);
    }
  }, [apiCallsMade]);

  useEffect(() => {
    WeeklyReport();
  }, [page]);

  const WeeklyReport = async () => {
    setApiCallsMade(true);
    setagentspinner(true);

    // Use custom dates only if "Custome" is selected
    const useCustomDates = fromYear === "Custome";

    await axios
      .post(
        BaseUrl + "/reports/agentCount",
        {
          start_date: fromdate !== "" ? fromdate : "",
          end_date: todate !== "" ? todate : "",
          agent_id: selectedagent ? selectedagent : "",
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setagentspinner(true);
        if (res.data) {
          setagentspinner(false);
          setAgentLoginDataList(res.data.data);
          setPagination(res.data.count);
        } else {
          setagentspinner(false);
          setAgentLoginDataList([]);
          setPagination(0);
        }
      })
      .catch((error) => {
        setagentspinner(false);
        setAgentLoginDataList([]);
        setPagination(0);
        console.log(error);
      });
  };

  const WeeklyReport1 = async (ToPage1) => {
    setApiCallsMade(true);
    setagentspinner(true);

    const useCustomDates = fromYear === "Custome";

    await axios
      .post(
        BaseUrl + "/reports/agentCount",
        {
          start_date: fromdate !== "" ? fromdate : "",
          end_date: todate !== "" ? todate : "",
          agent_id: selectedagent ? selectedagent : "",
          offset: ToPage1,
          limit: 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setagentspinner(true);
        if (res.data) {
          setagentspinner(false);
          setAgentLoginDataList(res.data.data);
          setPagination(res.data.count);
        } else {
          setagentspinner(false);
          setAgentLoginDataList([]);
          setPagination(0);
        }
      })
      .catch((error) => {
        setagentspinner(false);
        setAgentLoginDataList([]);
        setPagination(0);
        console.log(error);
      });
  };

  const weeklyReportDataDownload = async () => {
    setIsLoading(true);
    const useCustomDates = fromYear === "Custome";

    await axios
      .post(
        BaseUrl + "/reports/download_agentCount",
        {
          start_date: fromdate !== "" ? fromdate : "",
          end_date: todate !== "" ? todate : "",
          agent_id: selectedagent ? selectedagent : "",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoading(true);
        if (response.data.status) {
          setIsLoading(false);
          let downloadEmailasPdf =
            BaseUrlReports + "files" + response.data.data.slice(1);
          window.open(downloadEmailasPdf);
          toast.success("Weekly Report Downloaded Successfully", toaststyle);
        } else {
          setIsLoading(false);
          toast.warning(response.data.message, toaststyle);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.warning("No Data Found", toaststyle);
      });
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleSelectAgentChange = (selectedOptions) => {
    setSelectedagent(selectedOptions);
  };

  const handleSubmit = () => {
    let valid = true;

    if (!fromYear) {
      setYearError("Please select a date range.");
      valid = false;
    } else {
      setYearError("");
    }

    if (fromYear === "Custome") {
      if (!fromdate) {
        setFromDateError("From date is required.");
        valid = false;
      } else if (moment(fromdate).isAfter(todate)) {
        setFromDateError("From date should be less than or equal to To date.");
        valid = false;
      } else {
        setFromDateError("");
      }

      if (!todate) {
        setToDateError("To date is required.");
        valid = false;
      } else {
        setToDateError("");
      }
    }

    if (!valid) {
      setShowFilter(true);
      return;
    }

    WeeklyReport1(0);
    setPage(1);
    handelCloseFilter();
  };

  const resetButton = () => {
    setSelectedagent("");
    setFromYear("");
    setSelectedMonth(currentMonth);
    setFromdate(todayDate);
    setTodate(todayDate);
    setFromDateError("");
    setToDateError("");
    setYearError("");
    setReset(true)
  };

  return (
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Agent Statistics Report
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.setSelectedMenu("ReportMenu");
                }}
              >
                <IoIosArrowBack className="me-2" />
                Back
              </Button>

              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={weeklyReportDataDownload}
                disabled={isLoading}
              >
                <DownloadSimple className="me-2" />
                {isLoading ? "Downloading..." : "Download Report"}
              </Button>
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={handelShowFilter}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <StyledTableHead>
                  <StyledTableRow>
                    {[
                      "Agent Name",
                      "Outbound",
                      "Presentend",
                      "Answered",
                      "Abandoned",
                    ].map((headers) => (
                      <StyledTableCell style={{ minWidth: "150px" }}>
                        {headers}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  {agentspinner ? (
                    <Stack
                      sx={{ position: "absolute", top: "50%", left: "50%" }}
                    >
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) : agentlogindatalist && agentlogindatalist.length > 0 ? (
                    agentlogindatalist.map((item) => {
                      console.log("itemmmm", item);
                      return (
                        <StyledTableRow hover role="checkbox" tabIndex={-1}>
                          <StyledTableCell2>
                            {item.agent_name ? item.agent_name : "--"}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.outbound_count}
                          </StyledTableCell2>
                          <StyledTableCell2>
                            {item.presented_count}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.answered_count}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {item.abandoned_count}
                          </StyledTableCell2>
                        </StyledTableRow>
                      );
                    })
                  ) : (
                    <Stack
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "calc(100vh - 14rem)",
                      }}
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Stack
                        className="text-muted"
                        direction="column"
                        justifyContent="center"
                        alignContent="center"
                      >
                        <span className="mx-auto">
                          <img
                            src={Nodata}
                            alt="pic"
                            style={{ width: "11rem", userSelect: "none" }}
                          />
                        </span>
                        <span className="mx-auto">
                          <h6
                            className="text-muted mt-3"
                            style={{ fontSize: "13px" }}
                          >
                            Data unavailable
                          </h6>
                        </span>
                      </Stack>
                    </Stack>
                  )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing{" "}
                {Math.min(
                  (page - 1) * 10 + 1,
                  isNaN(pagination) ? 0 : pagination
                )}{" "}
                to {Math.min(page * 10, isNaN(pagination) ? 0 : pagination)} of{" "}
                {isNaN(pagination) ? 0 : pagination} entries
              </Typography>
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                variant="outlined"
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setShowFilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="exampleInputfromdate" className="form-label">
                    Select Date Range <small className="text-danger">*</small>
                  </label>
                  <select
                    value={fromYear}
                    onChange={handleYearChange}
                    className="form-control form-control-lg"
                    id="exampleInputfromdate"
                  >
                    <option value="">--Select Date Range--</option>
                    <option value="Today">Today</option>
                    <option value="ThisWeek">This Week</option>
                    <option value="LastWeek">Last Week</option>
                    <option value="ThisMonth">This Month</option>
                    <option value="LastMonth">Last Month</option>
                    <option value="Custome">Custom</option>
                  </select>
                  {yearError && <div className="text-danger">{yearError}</div>}
                </div>

                {fromYear === "Custome" && (
                  <>
                    <div className="mb-3 d-flex flex-column text-start">
                      <label
                        htmlFor="exampleInputfromdate"
                        className="form-label"
                      >
                        From Date <small className="text-danger">*</small>
                      </label>
                      <input
                        type="date"
                        value={fromdate}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFromdate(value);
                          if (!value) {
                            setFromDateError("From date is required.");
                          } else if (moment(value).isAfter(todate)) {
                            setFromDateError(
                              "From date should be less than or equal to To date."
                            );
                          } else {
                            setFromDateError("");
                          }
                        }}
                        className="form-control form-control-lg"
                        id="exampleInputfromdate"
                        max={todayDate}
                      />
                      {fromDateError && (
                        <span
                          className="text-danger mt-2"
                          style={{ fontSize: "10px" }}
                        >
                          {fromDateError}
                        </span>
                      )}
                    </div>
                    <div className="mb-3 d-flex flex-column text-start">
                      <label
                        htmlFor="exampleInputtodate"
                        className="form-label"
                      >
                        To Date <small className="text-danger">*</small>
                      </label>
                      <input
                        value={todate}
                        type="date"
                        onChange={(e) => {
                          const value = e.target.value;
                          setTodate(value);
                          if (!value) {
                            setToDateError("To date is required.");
                          } else {
                            setToDateError("");
                          }
                        }}
                        className="form-control form-control-lg"
                        id="exampleInputtodate"
                        max={todayDate}
                      />
                      {toDateError && (
                        <span
                          className="text-danger mt-2"
                          style={{ fontSize: "10px" }}
                        >
                          {toDateError}
                        </span>
                      )}
                    </div>
                  </>
                )}

                
              </div>
              
              <div className="custom_div">

              <div className="mb-3 d-flex flex-column text-start">
                <label for="exampleInputfromdate" className="form-label">
                  Agent <small className="text-danger">*</small>
                </label>
                <select
                  className="form-control form-control-lg"
                  onChange={(e) => setSelectedagent(e.target.value)}
                  value={selectedagent}
                >
                  <option value="">All Agent</option>
                  {props.DropDownAgentList.length > 0 ? (
                    props.DropDownAgentList.map((item) => {
                      return (
                        <>
                          <option value={item.id}>{item.username}</option>
                        </>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </select>
              </div>
              </div>
            </form>
          </Stack>
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={handelCloseFilter}
            >
              Close
            </Button>
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="warning"
              disableElevation
              onClick={resetButton}
            >
              Reset
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Drawer>
    </StyledPaper>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
  getAvailableAgentList,
})(AgentStatisticsReport);
